module.exports = __webpack_public_path__ + "static/Ria-61dfd87840f4389aa8b724c8ae3fc1b1.png";